<template>
  <b-card class="border rounded-xl border-gray-200 mb-3">
    <!-- Header -->
    <div class="flex items-center justify-between pb-1 mb-2 border-b">
      <div>
        <h5 class="text-base font-semibold text-[#333333] mb-0.5">
          Follow Up Order
        </h5>
        <p class="text-xs md:text-sm text-[#828282] mb-0">
          Atur subsidi ongkir dengan lebih baik dan efisien.
        </p>
      </div>
      <b-form-checkbox
        id="toggle-follow-up-order"
        :checked="followUpOrder"
        switch
        class="custom-cs-switch mb-0"
        @change="onToggleFollowUpOrder"
      />
    </div>

    <!-- Body (Accordion List) -->
    <div
      v-show="followUpOrder"
      class="mt-2 space-y-2"
    >
      <div
        v-for="item in reminderData"
        :key="item.id"
        class="border border-gray-200 rounded-lg p-2 bg-white transition-all"
      >
        <!-- Item Header (Row with Checkbox & Chevron) -->
        <div class="flex items-center justify-between">
          <b-form-checkbox
            :id="`checkbox-follow-up-order-${item.id}`"
            :checked="item.isActive"
            class="custom-cs-checkbox mb-0"
            @change="onToggleReminderActive(item)"
          >
            <span class="text-sm font-medium text-[#1E293B]">{{ item.label }}</span>
          </b-form-checkbox>

          <button
            type="button"
            class="p-0 border-0 bg-transparent text-gray-400 hover:text-gray-600 cursor-pointer focus:outline-none flex items-center justify-center"
            @click="item.isOpenEdit = !item.isOpenEdit"
          >
            <feather-icon
              :icon="item.isOpenEdit ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              size="18"
            />
          </button>
        </div>

        <!-- Expanded Form (Textarea & Edit Actions) -->
        <div
          v-show="item.isOpenEdit"
          class="mt-2 pt-2 border-t border-gray-100"
        >
          <div class="flex items-center justify-between mb-1">
            <span class="text-sm font-medium text-[#333333]">
              Pesan Follow Up
            </span>
            <div class="flex items-center gap-2">
              <button
                type="button"
                class="text-primary text-xs font-medium hover:underline p-0 border-0 bg-transparent cursor-pointer"
                @click="onToggleEditMessage(item)"
              >
                {{ item.onEdit ? 'Simpan' : 'Edit' }}
              </button>
              <button
                type="button"
                class="text-gray-400 hover:text-gray-600 p-0 border-0 bg-transparent cursor-pointer flex items-center justify-center"
                title="Reset Pesan"
                @click="onResetMessageFollowUpOrder(item)"
              >
                <feather-icon
                  icon="RotateCwIcon"
                  size="14"
                />
              </button>
            </div>
          </div>

          <b-form-textarea
            v-model="item.message"
            maxlength="300"
            :disabled="!item.onEdit"
            class="resize-y text-sm custom-cs-textarea"
            rows="3"
            placeholder="Tampilkan gambar yang ada di testimoni"
            @input="onTextFollowUpOrder(item, $event)"
          />

          <div class="text-end text-xs text-[#999999] mt-0.5">
            {{ (item.message || '').length }}/300
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { followUporderDefault, followUporder } from '../config'

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      followUpOrder: false,
      followUporderDefault,
      reminderData: JSON.parse(JSON.stringify(followUporder)),
      isInternalUpdate: false,
    }
  },
  watch: {
    'formData.reminder': {
      immediate: true,
      handler(newReminder) {
        if (this.isInternalUpdate) return
        if (!newReminder || !Array.isArray(newReminder)) return

        if (newReminder.length > 0) {
          this.followUpOrder = true
          this.reminderData = this.reminderData.map(item => {
            const matching = newReminder.find(r => r.delay === item.delay)
            if (matching) {
              return {
                ...item,
                isActive: true,
                message: matching.message || item.message,
              }
            }
            return {
              ...item,
              isActive: false,
            }
          })
        }
      },
    },
  },
  methods: {
    onToggleFollowUpOrder(enabled) {
      this.followUpOrder = enabled
      if (enabled) {
        if (this.reminderData.every(r => !r.isActive)) {
          this.reminderData = this.reminderData.map(r => ({
            ...r,
            isActive: true,
          }))
        }
      }
      this.prepareReminderPayload()
    },
    onToggleReminderActive(item) {
      const target = this.reminderData.find(r => r.id === item.id)
      if (target) {
        target.isActive = !target.isActive
      }
      this.prepareReminderPayload()
    },
    onToggleEditMessage(item) {
      const target = this.reminderData.find(r => r.id === item.id)
      if (target) {
        target.onEdit = !target.onEdit
      }
    },
    onResetMessageFollowUpOrder(item) {
      const defaultItem = this.followUporderDefault.find(d => d.id === item.id)
      const target = this.reminderData.find(r => r.id === item.id)
      if (target) {
        if (defaultItem) {
          target.message = defaultItem.message
        }
        target.onEdit = false
      }
      this.prepareReminderPayload()
    },
    onTextFollowUpOrder(item, value) {
      const target = this.reminderData.find(r => r.id === item.id)
      if (target) {
        target.message = value
      }
      this.prepareReminderPayload()
    },
    prepareReminderPayload() {
      this.isInternalUpdate = true
      if (!this.followUpOrder || !Array.isArray(this.reminderData)) {
        this.$set(this.formData, 'reminder', [])
      } else {
        const payload = this.reminderData
          .filter(r => r.isActive)
          .map(r => ({
            delay: r.delay,
            message: r.message,
          }))
        this.$set(this.formData, 'reminder', payload)
      }
      this.$nextTick(() => {
        this.isInternalUpdate = false
      })
    },
  },
}
</script>

<style lang="scss">
.custom-cs-textarea {
  &:disabled {
    background-color: #FAFAFA !important;
    color: #333333 !important;
  }
}
</style>
